import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Loader from '../../../../Shared/Loader'
import Alert from '../../../../Shared/Alert'
import { adminGetSubscriptionItems } from '../../../../../api'
import PropTypes from 'prop-types'

class SubscriptionItemList extends Component {

  constructor (props) {
    super(props)
    this.state = {
      items: [],
      loading: false,
      error: null
    }
    this.abortController = null
  }

  componentDidMount () {
    this.loadItemsForSubscription()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.subscriptionId !== prevProps.subscriptionId) {
      this.loadItemsForSubscription()
    }
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  loadItemsForSubscription () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null }, () => {
      adminGetSubscriptionItems(this.props.subscriptionId, this.abortController).fetchPromise.then((response) => {
        this.setState({ loading: false, items: response })
      }).catch(() => {
        this.setState({ error: 'Failed to load subscription items', loading: false })
      })
    })
  }

  render () {
    return (
      <div style={{ position: 'relative', minHeight: '19px'}}>
        {this.state.loading && <Loader size={24}/>}
        {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
        {this.state.items.map((item, index) => {
          return <div key={index}>
            <span style={{ marginRight: '5px' }}>GIATA-ID: {item.giataId}</span>
            <span>{item.hotelName} {item.cityName} {item.countryName}</span>
          </div>
        })}
      </div>
    )
  }
}

SubscriptionItemList.propTypes = {
  subscriptionId: PropTypes.number.isRequired
}

export default withTranslation()(SubscriptionItemList)
